<div class="scrollable-section" #scrollableSection>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp(null)">
    <i class="material-icons">close</i>
  </button>


  <div>

    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">

      <div class="button-container location">

        <button *ngIf="appAttendanceModel.coordinates" mat-raised-button class="location-button"
          (click)="onLocationCheck()">
          <fa-icon icon="map-marker-alt"></fa-icon> Comprobar localización
        </button>
      </div>

      <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="onSubmit()" novalidate="">
        <div class="block">
          <div class="col-14">
            <div class="row justify-content-center">

              <div class="col-12 ml-2">
                <div class="row">

                  <div class="col-6 " *ngIf="!defaultData">
                    <app-dropdown-formularios *ngIf="!inputData" dataSize="7" placeHolder="Empresas" [selectedValue]=""
                      (selectedValueChange)="companySelectedChanged($event)" [required]="true"
                      [dropdownType]="'Companies'" detailedData="true">
                    </app-dropdown-formularios>

                    <app-form-input-app *ngIf="inputData" [labelText]="'Empresa'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceModel.companyData.name" name="company" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-6 " *ngIf="!defaultData">
                    <app-dropdown-formularios *ngIf="!inputData" dataSize="7" placeHolder="Empleado" [selectedValue]=""
                      (selectedValueChange)="employeeChanged($event)" [isDisabled]="!appAttendanceModel.company"
                      [id]="appAttendanceModel.company" [required]="appAttendanceModel.company" [dropdownType]="'Users'"
                      detailedData="true">
                    </app-dropdown-formularios>

                    <app-form-input-app *ngIf="inputData" [labelText]="'Empleado'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceModel.userData.fullName" name="Empleado" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-6 " *ngIf="!defaultData">
                    <app-dropdown-formularios *ngIf="!inputData" dataSize="7" placeHolder="Centro" [selectedValue]=""
                      [isDisabled]="!appAttendanceModel.company" (selectedValueChange)="workCenterChanged($event)"
                      [required]="appAttendanceModel.company" [companyData]="appAttendanceModel.companyData"
                      detailedData="true" [dropdownType]="'WorkCenter'">
                    </app-dropdown-formularios>

                    <app-form-input-app *ngIf="inputData" [labelText]="'Centro'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceModel.workCenterData.name" name="workCenter" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-6 " *ngIf="!defaultData">
                    <app-dropdown-formularios *ngIf="!inputData" dataSize="7" placeHolder="Tipo" [selectedValue]=""
                      [isDisabled]="!appAttendanceModel.company" (selectedValueChange)="attendanceTypeChanged($event)"
                      [required]="appAttendanceModel.company" [companyData]="appAttendanceModel.companyData"
                      [dropdownType]="'AttendanceType'">
                    </app-dropdown-formularios>

                    <app-form-input-app *ngIf="inputData" [labelText]="'Tipo'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceModel.typeData.name" name="type" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-3 " *ngIf="!defaultData">

                    <app-form-input-app *ngIf="!inputData" [labelText]="'Fecha y hora'" [isRequired]="true">

                      <dx-date-box id="dateEnd" type="datetime" [max]="maxDate" [displayFormat]="'dd/MM/yyyy HH:mm'"
                        [inputAttr]="{ 'aria-label': 'Fecha y hora', 'style': 'padding: 9px !important; font-size: 14px !important;' }"
                        style="max-height: 2.8em; width: 100%; background: transparent !important;"
                        (onValueChanged)="onDateChange($event)">
                      </dx-date-box>
                    </app-form-input-app>


                    <app-form-input-app *ngIf="inputData" [labelText]="'Fecha y hora'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="dateAndHour" name="date" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-3 " *ngIf="!defaultData">
                    <app-form-input-app [labelText]="'Zona horaria'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceModel.timeZone" name="timeZone" required="true">
                    </app-form-input-app>
                  </div>



                  <!-- Con defaultData -->
                  <div class="col-6 " *ngIf="defaultData">
                    <app-form-input-app [labelText]="'Empresa'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceModel.companyData.name" name="company" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-6 " *ngIf="defaultData">
                    <app-form-input-app [labelText]="'Empleado'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceModel.userData.fullName" name="Empleado" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-6 mt-3" *ngIf="defaultData">
                    <app-dropdown-formularios dataSize="7" placeHolder="Centro" [selectedValue]=""
                      [isDisabled]="!appAttendanceModel.company" (selectedValueChange)="workCenterChanged($event)"
                      [required]="appAttendanceModel.company" [companyData]="appAttendanceModel.companyData"
                      detailedData="true" [dropdownType]="'WorkCenter'">
                    </app-dropdown-formularios>
                  </div>

                  <div class="col-6 mt-3 " *ngIf="defaultData">
                    <app-dropdown-formularios dataSize="7" placeHolder="Tipo" [selectedValue]=""
                      [isDisabled]="!appAttendanceModel.company" (selectedValueChange)="attendanceTypeChanged($event)"
                      [required]="appAttendanceModel.company" [companyData]="appAttendanceModel.companyData"
                      [dropdownType]="'AttendanceType'">
                    </app-dropdown-formularios>
                  </div>

                  <div class="col-3 mt-2 " *ngIf="defaultData">
                    <app-form-input-app [labelText]="'Fecha y hora'" [isRequired]="true" class="date-picker"> <!-- para cambiarlo se usa ngAfterViewInit -->
                      <dx-date-box id="dateEnd" type="datetime" [max]="maxDate" [displayFormat]="'dd/MM/yyyy HH:mm'"
                        [inputAttr]="{ 'aria-label': 'Fecha y hora', 'style': 'padding: 6px !important; font-size: 14px !important;' }"
                        style="max-height: 2.8em; width: 100%; background: transparent !important;"
                        (onValueChanged)="onDateChange($event)">
                      </dx-date-box>
                    </app-form-input-app>
                  </div>

                  <div class="col-3 mt-4 pt-1" *ngIf="defaultData">
                    <app-dropdown-formularios dataSize="7" placeHolder="Zona horaria" [selectedValue]=""
                      [isDisabled]="!appAttendanceModel.company" (selectedValueChange)="onTimeZoneChange($event)"
                      [required]="true" [selectedValue]="selectedTimeZone"
                      [dropdownType]="'TimeZone'">
                    </app-dropdown-formularios>
                  </div>

                  <div class="col-6 ">
                    <app-form-input-app [labelText]="'Origen'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceModel.source" name="source" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-6">
                    <app-form-input-app [labelText]="'Notas'" [isRequired]="false">
                      <textarea class="form-control" autocomplete="off" rows="1" maxlength="300"
                        style="resize: none; overflow-y: Auto;" [(ngModel)]="notes" name="notes" required="false"
                        (input)="autoGrow($event)">
                      </textarea>
                    </app-form-input-app>
                  </div>

                  <div class="col-6" *ngIf="appAttendanceModel.modifiedByData?.fullName">
                    <app-form-input-app [labelText]="'Modificado por'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceModel.modifiedByData.fullName" name="modifiedBy" required="true">
                    </app-form-input-app>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Botonera -->
        <div class="row">
          <label class="col-md-3"></label>
          <div class="col-md-9">
            <div class="form-group form-button">
              <button *ngIf="!inputData || defaultData || notes" class="btn btn-fill btn-primary float-right"
                type="submit" [disabled]="isDisabled()">
                Guardar
              </button>
              <a class="btn btn-fill btn-outline-white float-right" (click)="closePopUp(null)">Volver</a>
            </div>
          </div>
        </div>
      </form>
    </app-generic-panel>

  </div>




</div>